import { forwardRef } from 'react';
import { Button } from '@zoopla-eng/zds-components/button';
import { StyledAnswerContainer, StyledAnswerText } from '../../question.styles';

export const SavedQuestion = forwardRef<
    HTMLButtonElement,
    {
        id: string;
        text: string;
        questionLabel: string;
        testId?: string;
        onEdit: (id: string) => void;
        showEditButton?: boolean;
    }
>(({ id, text, questionLabel, onEdit, testId, showEditButton }, ref) => (
    <StyledAnswerContainer data-testid={testId}>
        <StyledAnswerText>
            <span id={id}>{questionLabel}</span>
            <strong>{text}</strong>
        </StyledAnswerText>
        {showEditButton && (
            <Button
                category="tertiary"
                onClick={() => onEdit(id)}
                ref={ref}
                aria-label={`Edit ${text}`}
                aria-describedby={id}
            >
                Edit
            </Button>
        )}
    </StyledAnswerContainer>
));
